import styled, { css } from 'styled-components';

import { stackingContext } from '@pkg/components/Modal/styles';
import { MODAL_CLOSE_OFFSET, MODAL_LAYOUT_SPACING } from '@pkg/components/Modal/tokens';

import { ModalCloseButtonPositions } from '../../Modal.types';

import { ModalHeaderAlignments } from './Header.types';

const modalHeaderAlignmentsToFlex = {
    [ModalHeaderAlignments.Left]: 'start',
    [ModalHeaderAlignments.Center]: 'center',
    [ModalHeaderAlignments.Right]: 'end',
};

export const HeaderWrapper = styled.div`
    --yat_modal-layout-gap: ${MODAL_LAYOUT_SPACING}px;

    grid-area: header;

    display: flex;
    align-items: center;
    justify-content: start;
    font-weight: 700;
`;

interface HeaderContentProps {
    $align: ModalHeaderAlignments;
}

export const HeaderContent = styled.div<HeaderContentProps>`
    display: flex;
    align-items: center;
    justify-content: ${({ $align }) => modalHeaderAlignmentsToFlex[$align]};
    flex-grow: 1;
`;

interface CloseActionWrapperProps {
    $position: ModalCloseButtonPositions;
}

export const CloseActionWrapper = styled.div<CloseActionWrapperProps>`
    grid-area: close;

    ${({ $position }) => {
        switch ($position) {
            case ModalCloseButtonPositions.Header:
                return css`
                    position: static;
                    transform: translateX(50%);

                    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
                        transform: none;
                    }
                `;
            case ModalCloseButtonPositions.Corner:
            default:
                return css`
                    position: absolute;
                    z-index: ${stackingContext.closeAction};
                    top: ${MODAL_CLOSE_OFFSET}px;
                    right: ${MODAL_CLOSE_OFFSET}px;
                `;
        }
    }}
`;
